import React from "react";
import {Container, Row, Col, Image, Button} from "react-bootstrap";
import DotsImage from "../assets/img/dots-1.svg";
import SmsApisImage from "../assets/img/group-21.png";
import ReportingImage from "../assets/img/group-427318293.png";
import WebPortalImage from "../assets/img/hlr_new.png";
import SmppImage from "../assets/img/group-25.png";
import PredefinedRoutingImage from "../assets/img/group-24.png";
import DeliveryImage from "../assets/img/group-26.png";
import { useNavigate } from "react-router-dom";

const SectionSix = () => {
  const navigate = useNavigate();
  return (
    <section id="mngservices" className=" my-5 py-5 overflow-hidden">
      <Container>
        <div className="overflow-hidden">
          <Col lg={7} className="mx-auto text-center overflow-hidden">
            <p className="mx-2 px-2 mb-5 display-5 fw-normal">
              <strong className="gradient-text">MANAGED SERVICES</strong> <br />
            </p>
            <p className="gradient-text" style={{ fontSize : "large", fontWeight : "bolder"}}>We manage the complexity so operators can focus on growth, performance and customer experience</p>

          </Col>
        </div>
        <Row className="sx-overlap">
          <Col xs={12} md={4} className="mb-4">
            <div className="sx-frame">
              <Image className="sx-img" src={SmsApisImage} fluid />
              <div className="sx-text-wrapper">SMS Monetisation</div>
              <p className="sx-p">
                Our SMS monetisation offering is delivered as a fully managed service that
                helps operators secure and protect revenue from messaging traffic while
                maintaining control over pricing routing and traffic quality. Supported by
                fraud prevention and security capabilities including SMS Firewall and flash
                call protection the service safeguards networks against spam fraud and
                abuse ensuring compliance and long-term revenue protection.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col xs={12} md={4} className="mb-4">
            <div className="sx-frame">
              <Image className="sx-img" src={ReportingImage} fluid />
              <div className="sx-text-wrapper">Mobile Intelligence</div>
              <p className="sx-p">
                Digi-Touch Mobile Intelligence is a fully managed service that enables mobile
                operators to unlock new revenue from their network and subscriber data.
                Through secure, compliant, and standardized APIs, operators can expose
                trusted network intelligence for digital identity, authentication, and
                verification use cases. By bridging telecom networks with the digital
                ecosystem, the service helps operators protect revenues, accelerate innovation,
                and build scalable data-driven partnerships while maintaining full control,
                compliance, and data integrity.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col xs={12} md={4} className="mb-4">
            <div className="sx-frame">
              <Image className="sx-img" src={WebPortalImage} fluid />
              <div className="sx-text-wrapper">MNP/HLR Enablement</div>
              <p className="sx-p">
                Our MNP and HLR enablement is delivered as a fully managed service, enabling
                mobile network operators to monetize core network data intelligence without
                added operational complexity. By converting real-time subscriber and number
                portability insights into value-added services, we help operators improve
                routing accuracy, enhance delivery performance, and unlock new revenue
                opportunities across messaging and voice.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col xs={12} md={6} className="mb-4">
            <div className="sx-frame">
              <Image className="sx-img" src={SmppImage} fluid />
              <div className="sx-text-wrapper">Wholesale SMS Platform</div>
              <p className="sx-p">
                Our Wholesale SMS Platform is a fully managed, carrier-grade solution for MNOs,
                aggregators, and wholesale messaging providers to control and grow their SMS business.
                It brings routing logic, rate management, real-time billing, analytics, and policy
                controls into a single platform enabling automated operations, full traffic visibility,
                and new revenue opportunities without the need to build or manage messaging infrastructure.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col xs={12} md={6} className="mb-4">
            <div className="sx-frame">
              <Image className="sx-img" src={PredefinedRoutingImage} fluid />
              <div className="sx-text-wrapper">Network Penetration Testing</div>
              <p className="sx-p">
                Digi-Touch Network Penetration Testing is a neutral, non-intrusive managed
                service that helps mobile operators uncover A2P bypass, validate controls,
                and protect messaging revenues. By simulating real application behaviour
                across SMS, voice, and IP-based channels, the service exposes how A2P traffic
                is delivered to their network, revealing leakage, firewall blind spots,
                and bypass techniques so operators can take data-driven actions to recover and secure A2P revenue.
              </p>
              {/*<div className="sf-cta">*/}
              {/*  <Button*/}
              {/*      onClick={() => navigate("/contact")}*/}
              {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
              {/*  >*/}
              {/*    Contact Us*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </div>
          </Col>
          {/*<Col xs={12} md={4} className="mb-4">*/}
          {/*  <div className="sx-frame">*/}
          {/*    <Image className="sx-img" src={DeliveryImage} fluid />*/}
          {/*    <div className="sx-text-wrapper">Delivery</div>*/}
          {/*    <p className="sx-p">*/}
          {/*      Priority-based routing ensures mission-critical SMS delivery*/}
          {/*      first. Multiple priority levels let you fast-track your queue,*/}
          {/*      ideal for concurrent marketing campaigns and time-sensitive*/}
          {/*      notifications via one account.*/}
          {/*    </p>*/}
          {/*  </div>*/}
          {/*</Col>*/}
        </Row>
      </Container>
      {/*<div className="sx-dots-image-container">*/}
      {/*  <div id="whyus" className="dot-background">*/}

      {/*  </div>*/}
      {/*</div>*/}
    </section>
  );
};

export default SectionSix;
